import React from "react";
import styled from "styled-components";

const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
`;

const Card = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #4caf50;

  @media (max-width: 768px) {
    padding: 12px;
  }
`;

const CardTitle = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const CardValue = styled.div`
  font-size: 32px;
  font-weight: bold;
  color: #333;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

const MetricsCards = ({ cards }) => (
  <CardsContainer>
    {cards.map((card) => (
      <Card key={card.title}>
        <CardTitle>{card.title}</CardTitle>
        <CardValue>{card.value}</CardValue>
      </Card>
    ))}
  </CardsContainer>
);

export default MetricsCards;
